import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

const suburbs = [
  "Borrowdale",
  "Highlands",
  "Langhorn Lane",
  "Mount Pleasant",
  "CBD",
  "Unknown",
  "Harare",
  "Avenue",
  "Borrowdale Brooke",
  "Other",
];

const suburbCapacities = [1600, 400, 200, 150, 100, 90, 80, 70, 60, 50];

export default function TopSuburbsByCapacityWidget() {
  return (
    <Card sx={{ height: "100%", borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Top 10 Suburbs by Capacity
        </Typography>

        <BarChart
          xAxis={[
            {
              data: suburbs,
              scaleType: "band",
              label: "suburb",
            },
          ]}
          yAxis={[
            {
              label: "capacity",
            },
          ]}
          series={[
            {
              data: suburbCapacities,
            },
          ]}
          height={300}
        />
      </CardContent>
    </Card>
  );
}
